type OrderItemReferenceInput = {
  snapshotSku?: string | null;
};

export const getOrderItemReference = ({ snapshotSku }: OrderItemReferenceInput): string | null =>
  snapshotSku?.trim() || null;
